<div>
  <h2>{{ 'Administration::AiTestingSettings' | abpLocalization }}</h2>
</div>
<br />
<hr />
@if (aiTestingSettingsForm) {
  <div class="info-box mb-1 mt-1 w-100">
    <div class="info-box-icon">
      <i class="fa-solid fa-triangle-exclamation"></i>
    </div>
    <div class="info-box-content">
      {{ 'Administration::AiTestingSettingsDisclaimer' | abpLocalization }}
    </div>
  </div>
  <div class="mb-3">
    <cai-llm-settings
      [formGroup]="aiTestingSettingsForm"
      [llmConfigurationList]="llmConfigurationList"
      [groupedModelList]="suggestedModels"
      [isUpdateMode]="true"
      [enableReasoningEffortSelection]="true"
    ></cai-llm-settings>
  </div>
  <abp-button
    (click)="submitForm()"
    iconClass="fa-solid fa-check"
    [loading]="isLoading"
    [disabled]="isSaveDisabled()"
  >
    {{ 'AbpUi::Save' | abpLocalization }}
  </abp-button>
}
